import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import CloseIcon from "@mui/icons-material/Close";

const TransparentHeader = ({
  showLeftIcon = false,
  leftIconCallbackMethod,
  logoUrl,
  titleHeader,
  color,
}) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);

  const handleFullscreenToggle = () => {
    const element = document.documentElement;
    if (!isFullscreen) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else {
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.height = "100%";
        document.body.style.top = "0";
        document.body.style.left = "0";
        document.body.style.overflow = "hidden";
        document.documentElement.style.background = "black";
      }
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else {
        document.body.style.position = "";
        document.body.style.width = "";
        document.body.style.height = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.overflow = "";
        document.documentElement.style.background = "";
      }
      setIsFullscreen(false);
    }
  };

  const topOffset = 25;

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          top: `${topOffset}px`,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {showLeftIcon ? (
            <IconButton
              color="error"
              onClick={() => {
                if (leftIconCallbackMethod) {
                  leftIconCallbackMethod();
                }
              }}
              sx={{ fontSize: 45 }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          ) : (
            <Box sx={{ width: 48 }} />
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              gap: 2,
            }}
          >
            {logoUrl && (
              <img
                src={logoUrl}
                alt="Logo"
                style={{
                  height: 40,
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            )}
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Roboto, sans-serif",
                color: color !== "" ? color : "#607D8B",
                fontSize: "1.8rem",
                fontWeight: 500,
                letterSpacing: "0.5px",
              }}
            >
              {logoUrl && titleHeader ? titleHeader : "Fiducia AI"}
            </Typography>
          </Box>

          {/* <IconButton
            color="#607D8B"
            onClick={handleFullscreenToggle}
            sx={{ fontSize: 45 }}
          >
            {isFullscreen ? (
              <FullscreenExitIcon fontSize="inherit" />
            ) : (
              <FullscreenIcon fontSize="inherit" />
            )}
          </IconButton> */}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: {
            width: 250,
            backgroundColor: "#f2f2f2",
            opacity: 0.95,
          },
        }}
      >
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={handleDrawerClose}
          onKeyDown={handleDrawerClose}
        >
          <List>
            {[
              "Buy Now!",
              "Try Sports GPT",
              "Open 3D Viewer",
              "View in a Room",
            ].map((text) => (
              <React.Fragment key={text}>
                <ListItem button>
                  <ListItemText primary={text} />
                  <ListItemIcon>
                    <FullscreenIcon />
                  </ListItemIcon>
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default TransparentHeader;
